import { Button, Typography } from '@mui/material';
import React from 'react';
import { AuthEventKeys, AuthEvents } from '../events';
import { EventBus } from '@/shared/utils';
import { Auth } from '@/shared/i18n';

type RegisterSectionProps = {
  eventBus: EventBus<AuthEvents>;
  dict: Auth;
};

const RegisterSection = ({ eventBus, dict }: RegisterSectionProps) => {
  const handleRegisterClick = () => {
    eventBus.emit(AuthEventKeys.register.view, undefined);
  };

  return (
    <section className="flex flex-col gap-2 items-center px-16 py-8 max-w-full rounded-xl bg-paper w-[600px] max-md:px-5">
      <Typography variant="s1" component="h2" color="textPrimary">
        {dict.login?.register_prompt || 'Non hai un account?'}
      </Typography>
      <Button
        size="large"
        variant="text"
        color="primary"
        className="w-full mt-2 whitespace-nowrap"
        onClick={handleRegisterClick}
      >
        <Typography variant="button-l">{dict.register?.button_text || 'Registrati'}</Typography>
      </Button>
    </section>
  );
};

export default RegisterSection;
